import WebSocketConnect from "@/pages/WebSocketConnect";

// Single Pages
import AuthLayout from "@/pages/Auth/AuthLayout.vue";
import Login from "@/pages/Auth/Login.vue";


//Dispatching
import DashboardLayout from "@/pages/Layout/DevicesLayout.vue";

import Messenger from "@/pages/Messenger"
import Location from "@/pages/Location"


import store from '@/storage/store';


function getAuth() {
  return store.getters.getAuth;
}

function isSignedIn() {
  try {
    if (getAuth().expiration > new Date().getTime()) {
      return true;
    }
  } catch (err) {
    return false;
  }
  return false;
}

function requireAuth(to, from, next) {

  if (!isSignedIn()) {
    next({
      path: '/login'
    });
  } else {
    next();
  }
}




const authPages = {
  path: "/login",
  component: AuthLayout,
  children: [
    {
      path: "",
      name: "Login",
      component: Login
    }
  ]
};

const routes = [
  {
    path: "",
    component: WebSocketConnect,
    name: "WSConnect",
    children: [
      {
        path: "",
        component: DashboardLayout,
        beforeEnter: requireAuth,
        redirect: "/dispatching",
        children: [
          {
            path: "dispatching",
            name: "dispatching",
            meta: {
              hideFooter: true
            },
            components: { default: Messenger }
          },
          {
            path: "location",
            name: "location",
            components: { default: Location }
          }
        ]
      }
    ]
  },
  authPages,

  //DEFAULT ROUTE TODO: 404
  { path: "*", redirect: "/login" }
];

export default routes;
